import React, { useState, useEffect, useContext } from 'react';
import { AuthContext } from '@/App';
import { Link } from 'react-router-dom';
import { Sparkles, X, ArrowRight, ShieldAlert } from 'lucide-react';

const TrialBanner = () => {
  const { user } = useContext(AuthContext);
  const [dismissed, setDismissed] = useState(false);

  useEffect(() => {
    const isDismissed = sessionStorage.getItem('dismissed_trial_banner') === 'true';
    if (isDismissed) {
      setDismissed(true);
    }
  }, []);

  if (dismissed || !user) return null;

  // No mostrar a administradores ni a usuarios con suscripción activa de pago
  if (user.role === 'admin') return null;
  if (user.subscription_status === 'active' && user.subscription_tier !== 'free') return null;

  // Solo mostrar si el usuario está efectivamente en estado de prueba (trialing)
  const isTrial = user.subscription_status === 'trialing';
  if (!isTrial) return null;

  // Calcular días restantes
  let remainingDays = 7;
  if (user.trial_ends_at) {
    const endDate = new Date(user.trial_ends_at);
    const now = new Date();
    const diff = endDate - now;
    remainingDays = Math.max(1, Math.ceil(diff / (1000 * 60 * 60 * 24)));
  }

  const handleDismiss = (e) => {
    e.preventDefault();
    e.stopPropagation();
    setDismissed(true);
    sessionStorage.setItem('dismissed_trial_banner', 'true');
  };

  return (
    <div className="bg-gradient-to-r from-amber-500 via-orange-500 to-purple-600 text-white px-4 py-2.5 shadow-md relative z-30 animate-in fade-in duration-300">
      <div className="max-w-7xl mx-auto flex items-center justify-between gap-3 text-xs sm:text-sm">
        <div className="flex items-center gap-2.5 flex-1 min-w-0">
          <div className="p-1.5 bg-white/20 rounded-lg shrink-0">
            <Sparkles className="w-4 h-4 text-amber-100 animate-pulse" />
          </div>
          <p className="font-semibold truncate leading-snug">
            <span className="font-extrabold text-amber-100">¡Tienes {remainingDays} {remainingDays === 1 ? 'día' : 'días'} de beneficio de prueba!</span>{' '}
            <span className="hidden sm:inline opacity-95">Si compras hoy, tus días restantes se sumarán a tu mensualidad.</span>
          </p>
        </div>

        <div className="flex items-center gap-2 shrink-0">
          <Link
            to="/pricing"
            className="px-3 py-1 bg-white text-slate-900 font-extrabold rounded-xl text-xs hover:bg-slate-100 active:scale-95 transition-all shadow-sm flex items-center gap-1"
          >
            <span>Asegurar Plan</span>
            <ArrowRight className="w-3 h-3" />
          </Link>

          <button
            onClick={handleDismiss}
            className="p-1 hover:bg-white/20 rounded-lg transition-colors text-white/80 hover:text-white"
            title="Cerrar aviso por esta sesión"
          >
            <X className="w-4 h-4" />
          </button>
        </div>
      </div>
    </div>
  );
};

export default TrialBanner;
